import React from 'react';

export const CancelAccountContext = React.createContext({
	cancelData: null,
	Dropdown1Answer: '',
	Dropdown1Other: '',
	Dropdown2Answer: '',
	Dropdown2Other: '',
	Dropdown3Answer: '',
	Dropdown3Other: '',
	HasViewedDowngrade: null,
	AcceptedDowngrade: null,
	canceled: null,
	setStep: () => {},
	saveCancelAccountInfo: () => {},
	optimizely: null,
	offeredPlanId: null,
});
